import {createContext,useCallback,useContext,useEffect,useRef,useState,type ReactNode} from 'react';
import {DialogHostContext,type DialogLayer} from '@platform/ui/Dialog';
import {NoticeHostContext} from '@platform/ui/Notice';
import {useWebViewport} from '@platform/ui/config';
import './RoomOverlays.css';

const HostSetter=createContext<(host:HTMLDivElement|null)=>void>(()=>{});
const NoticeHostSetter=createContext<(host:HTMLDivElement|null)=>void>(()=>{});

// One visual shade, no inert background or scroll lock. Dialogs and the shared
// footer are siblings, so the shade cannot dim or intercept the action area.
export function RoomOverlays({children}:{children:ReactNode}){
 const [host,setHost]=useState<HTMLDivElement|null>(null),[layers,setLayers]=useState<DialogLayer[]>([]);
 const [noticeHost,setNoticeHost]=useState<HTMLDivElement|null>(null);
 const active=useRef(layers);active.current=layers;
 const register=useCallback((element:HTMLDialogElement,close:()=>void)=>{
  setLayers(previous=>[...previous.filter(item=>item.element!==element),{element,close}]);
  return()=>setLayers(previous=>previous.filter(item=>item.element!==element));
 },[]);
 useEffect(()=>{
  const escape=(event:KeyboardEvent)=>{
   if(event.key!=='Escape')return;
   // A nested menu/select gets its own Escape first. Native non-modal dialogs
   // do not supply modal Escape/focus trapping, so close only the top panel.
   const top=active.current.at(-1);
   queueMicrotask(()=>{if(top&&!event.defaultPrevented&&active.current.at(-1)===top)top.close();});
  };
  document.addEventListener('keydown',escape);return()=>document.removeEventListener('keydown',escape);
 },[]);
 return <DialogHostContext value={{host,layers,register}}><HostSetter value={setHost}><NoticeHostContext value={noticeHost}><NoticeHostSetter value={setNoticeHost}>{children}</NoticeHostSetter></NoticeHostContext></HostSetter></DialogHostContext>;
}

export function RoomOverlayHost(){
 const setHost=useContext(HostSetter),setNoticeHost=useContext(NoticeHostSetter),layer=useContext(DialogHostContext)!;
 const desktop=useWebViewport();
 return <><div ref={setHost} className="room-overlay-host">{layer.layers.length>0&&<div className="room-panel-shade" aria-hidden="true" style={{zIndex:59+layer.layers.length*2}}/>}</div>{!desktop&&<div ref={setNoticeHost} className="room-feedback-stack"/>}</>;
}

// The active desktop catalogue owns feedback; the mobile edge stack stays
// above its bottom CTA. Form validation continues to render inside its form.
export function RoomCardFeedbackHost(){
 const desktop=useWebViewport(),setNoticeHost=useContext(NoticeHostSetter);
 return desktop?<div ref={setNoticeHost} className="room-feedback-stack"/>:null;
}
